module.exports = __webpack_public_path__ + "static/media/scaleH-icon.9feb665c.svg";